export default "__VITE_ASSET__Cd825QnW__"